module.exports = __webpack_public_path__ + "static/media/Kam.ffe19d1b.PNG";